/**
 * Sticky Header
 * Adds a class to header on scroll
 */
import magnificPopup from '../vendors/jquery-magnificpopup';
import organicTabs from '../vendors/organic-tab';
import masonry from '../vendors/masonry.min';
import customInput from '../partials/custom-inputs';
import OwlCarousel from '../vendors/owl.carousel.min';
import gsap from '../vendors/gsap.min';
import scrollTrigger from '../vendors/ScrollTrigger.min';
import drawSvg from '../vendors/DrawSVGPlugin.min';

jQuery( document ).on( 'scroll', function() {
	if ( jQuery( document ).scrollTop() > 50 && ! jQuery( 'body' ).hasClass( 'page-template-template-give' ) ) {
		jQuery( 'header, body' ).addClass( 'shrink' );
	} else if ( jQuery( document ).scrollTop() > 5 && jQuery( 'body' ).hasClass( 'page-template-template-give' ) ) {
		jQuery( 'header, body' ).addClass( 'shrink' );
	} else {
		jQuery( 'header, body' ).removeClass( 'shrink' );
	}
} );

jQuery.noConflict();

jQuery( window ).on( 'load resize', function() {
	const topBar_height = jQuery( '.top-bar' ).outerHeight();
	let logedin_topBar_height = jQuery( '.top-bar' ).outerHeight();
	const $header_height = jQuery( '.header-section' ).outerHeight();
	const $header_inner = jQuery( '.header-inner' ).outerHeight();
	const $wpAdminBar = jQuery( '#wpadminbar' ).outerHeight();
	const $paddingTopValue = jQuery( '.hero--home' ).css( 'padding-top' );

	// console.log(topBar_height);

	let adjustment = 0;
	if ( jQuery( 'body' ).hasClass( 'logged-in' ) ) {
		adjustment = 32;
		logedin_topBar_height = topBar_height - adjustment;

		if ( jQuery( window ).width() < 783 ) {
			adjustment = 46;
			logedin_topBar_height = topBar_height - adjustment;
		}
	}

	let programmNegHeight = $header_height + adjustment;

	if ( jQuery( window ).width() > 1003 ) {
		programmNegHeight = programmNegHeight + 81;
	} else if ( jQuery( window ).width() > 747 && jQuery( window ).width() < 1004 ) {
		programmNegHeight = programmNegHeight + 87;
	} else {
		programmNegHeight = programmNegHeight + 174;
	}

	jQuery( 'html' ).get( 0 ).style.setProperty( '--header_height', ( programmNegHeight ) + 'px' );

	// Update styles for .hero-section
	jQuery( '.hero-section' ).css( 'padding-top', ( $header_height ) + 'px' );
	jQuery( '.header-section' ).css( 'top', adjustment + 'px' );
	// Update styles for elements with classes .have-topbar and .hide-topbar

	jQuery( '.nav-overlay' ).css( 'padding-top', '0' );
	// if ( jQuery( window ).width() > 1179 ) {
	// 	jQuery( '.nav-overlay' ).css( 'padding-top', '0' );
	// }

	if ( jQuery( window ).width() < 1180 ) {
		jQuery( '.nav-overlay' ).css( 'top', ( adjustment + topBar_height ) + 'px' );
		console.log( topBar_height );
		jQuery( '.nav-overlay' ).css( 'padding-top', $header_inner + 'px' );

		jQuery( '.top-bar-cross' ).on( 'click', function() {
			jQuery( '.nav-overlay' ).css( 'top', ( adjustment ) + 'px' );
		} );
	}

	jQuery( '.top-bar-cross' ).on( 'click', function() {
		jQuery( '.header-section' ).css( 'top', -logedin_topBar_height + 'px' );
		jQuery( '.hero-section' ).css( 'padding-top', ( $header_height - topBar_height ) + 'px' );
		// console.log(logedin_topBar_height);
	} );
} );

jQuery( function() {
	jQuery( '.jump-link-shortcode' ).each( function() {
		const id = jQuery( this ).attr( 'id' );
		jQuery( this ).parents( '.faq-content' ).siblings( '.faq-head' ).addClass( id );
		jQuery( this ).parents( '.faq-content' ).addClass( 'content-' + id );
		jQuery( 'a[href="#' + id + '"]' ).addClass( 'faq-jump-link' );
	} );
	jQuery( document ).on( 'click', '.faq-jump-link', function( e ) {
		e.preventDefault();
		const id = jQuery( this ).attr( 'href' ).replace( '#', '' );
		jQuery( '.faq-head.' + id ).addClass( 'active' );
		jQuery( '.faq-content.content-' + id ).show( );
		jQuery( 'html, body' ).animate( {
			scrollTop: jQuery( '#' + id ).offset().top - 250,
		}, 0 );
	} );

	function extractUsernameFromUrl( url ) {
		// Define a regular expression to match the hashtagged username pattern
		const regex = /#([a-zA-Z0-9_-]+)/;

		// Use the match method to find the first match in the URL
		const match = url.match( regex );

		// Check if there is a match and return the extracted username or null
		return match ? match[ 1 ] : null;
	}
	if ( jQuery( '.team-members' ).length >= 1 ) {
		const currentUrl = window.location.href;
		const extractedUsername = extractUsernameFromUrl( currentUrl );
		setTimeout( () => {
			jQuery( '.team-member' ).find( 'a[href="#' + extractedUsername + '"]' ).eq( 0 ).click();
		}, 100 );
	}
	setTimeout( function() {
	// Get section Height
		const sectionHeight = jQuery( '.arrow-top' ).parents( 'section.ctn' ).prev( 'section.ctn' ).outerHeight();
		jQuery( '.arrow-top' ).css( { height: sectionHeight + 527, top: -( sectionHeight + 480 ) } );
	}, 20 );
	if ( jQuery( window ).width() < 748 ) {
		setTimeout( function() {
			// Get section Height
			const sectionHeight = jQuery( '.arrow-top' ).parents( 'section.ctn' ).prev( 'section.ctn' ).outerHeight();
			jQuery( '.arrow-top' ).css( { height: sectionHeight + 478, top: -( sectionHeight + 400 ) } );
		}, 20 );
	}

	// Perfect Wp-images

	const extLink = jQuery( 'body a' ).filter( function() {
		return this.hostname && this.hostname !== location.hostname;
	} );
	extLink.each( function() {
		jQuery( this ).attr( 'target', '_blank' );
		jQuery( this ).addClass( 'external-link' );
	} );

	// accessible sub menu
	jQuery( '.menu-item-has-children > a' )
		.on( 'focus', function() {
			jQuery( this ).siblings( '.sub-menu' ).addClass( 'focused' );
		} );

	jQuery( '.menu-item' ).not( '.menu-item-has-children' ).find( 'a' )
		.on( 'focus', function() {
			jQuery( '.sub-menu' ).removeClass( 'focused' );
		} )
		.on( 'blur', function() {
			jQuery( this ).siblings( '.sub-menu' ).removeClass( 'focused' );
		} );

	// jQuery( window ).load( function() {
	// 	if ( jQuery( document ).scrollTop() > 0 ) {
	// 		const $header_height = jQuery( 'header' ).outerHeight();
	// 		jQuery( 'body' ).css( 'padding-top', $header_height + 'px' );
	// 	} else {
	// 		const $header_height = jQuery( 'header' ).outerHeight();
	// 		jQuery( 'body' ).css( 'padding-top', $header_height + 'px' );
	// 	}
	// } );
	jQuery.fn.fullHtml = function() {
		const items = [];
		this.each( function() {
			// console.log( elements );
			let html = '';
			const tagName = jQuery( this ).prop( 'tagName' ).toLowerCase();
			const attributes = this.attributes;
			// console.log( attributes );
			html += '<' + tagName + ' ';
			jQuery.each( attributes, function() {
				html += ' ' + this.name + '="' + this.value + '" >';
			} );
			html += jQuery( this ).html() + '</' + tagName + ' >';
			items.push( html );
		} );
		return items;
	};

	if ( jQuery( 'body' ).hasClass( 'single-program' ) ) {
		const blogHTML = '';

		// let count = 1;
		const items = [];
		jQuery( '.program-consortium-content' )
			.find( 'h2.wp-block-heading,h3.wp-block-heading,.section-head h2' )
			.each( function() {
				const tagName = jQuery( this ).prop( 'tagName' ).toLowerCase();
				const id = jQuery( this )
					.text()
					.toLowerCase()
					.replace( /[^a-zA-Z0-9 ]/g, '' )
					.replace( /\s/g, '-' );
				const text = jQuery( this ).text();
				items.push( {
					id,
					text,
					tagName,
				} );
				jQuery( this ).replaceWith(
					'<div class="jump-link-post" id="' +
						id +
						'"></div>' +
						jQuery( this ).fullHtml()
				);
			} );
		// console.log( items );
		const mainList = jQuery( '.program-jump-links-tabs' );
		let currentH2;
		items.forEach( function( heading ) {
			const listItem = jQuery( '<li></li>' );
			const link = jQuery( '<a></a>' ).text( heading.text ).attr( 'href', '#' + heading.id );

			listItem.append( link );

			if ( heading.tagName === 'h2' ) {
				mainList.append( listItem );
				currentH2 = listItem;
			} else if ( heading.tagName === 'h3' && currentH2 ) {
				currentH2.addClass( 'has-child-items' );
				let subList = currentH2.find( 'ul' );
				if ( ! subList.length ) {
					subList = jQuery( '<ul></ul>' ).addClass( 'child-items' );
					currentH2.append( subList );
				}
				subList.append( listItem );
			}
		} );
		const currentUrl = window.location.href;
		const extraTabName = extractUsernameFromUrl( currentUrl );
		setTimeout( () => {
			jQuery( 'html, body' ).animate( {
				scrollTop: jQuery( '#' + extraTabName ).offset().top - 210,
			}, 0 );
		}, 1000 );

		const prevContentId = null;

		// jQuery( window ).scroll( function() {
		// 	const headings = document.querySelectorAll( '.jump-link-post' );

		// 	for ( let i = 0; i < headings.length; i++ ) {
		// 		const heading = headings[ i ];
		// 		const headingId = heading.id;
		// 		const headingElement = document.getElementById( headingId );

		// 		if ( isInViewport( headingElement ) ) {
		// 			updateTableOfContents( headingId );
		// 			prevContentId = headingId;
		// 			break;
		// 		}
		// 	}
		// } );

		// function updateTableOfContents( currentId ) {
		// 	if ( prevContentId ) {
		// 		const prevLink = jQuery(
		// 			'.program-jump-links-tabs a[href="#' + prevContentId + '"]'
		// 		);
		// 		prevLink.removeClass( 'current' );
		// 	}

		// 	const currentLink = jQuery(
		// 		'.program-jump-links-tabs a[href="#' + currentId + '"]'
		// 	);
		// 	currentLink.addClass( 'current' );

		// 	prevContentId = currentId;
		// }

		// function isInViewport( element ) {
		// 	const rect = element.getBoundingClientRect();
		// 	return (
		// 		rect.top >= 0 &&
		// 		rect.left >= 0 &&
		// 		rect.bottom <=
		// 			( window.innerHeight ||
		// 				document.documentElement.clientHeight ) &&
		// 		rect.right <=
		// 			( window.innerWidth || document.documentElement.clientWidth )
		// 	);
		// }
	}
	jQuery.noConflict();
	/**
	 * Search
	 */
	jQuery( '.header-search-icon' ).click( function() {
		jQuery( '.search-form-new' ).toggleClass( 'open' );
	} );
	jQuery( '.search-close,.menu-btn' ).click( function() {
		jQuery( '.search-form-new' ).removeClass( 'open' );
	} );

	jQuery.noConflict();

	jQuery.fn.topBar = function() {
		return this.each( function() {
			const element = jQuery( this );
			if ( 'undefined' !== typeof setWithExpiry ) {
				const topbar = getWithExpiry( '.top-bar' );
				if ( null == topbar ) {
					jQuery( 'body' ).addClass( 'have-topbar' );
					element.show();
				} else {
					jQuery( 'body' ).removeClass( 'have-topbar' );
					element.hide();
					element.height( 0 );
					element.css( 'padding', '0' );
				}
			} else {
				console.log( 'Please add the local-data dependency for the code to work fully -> topbar lib' );
			}
			element.find( '.top-bar-cross' ).click( function() {
				jQuery( this ).parents().find( 'body' ).addClass( 'hide-topbar' );
				jQuery( this ).parents().find( 'body' ).removeClass( 'have-topbar' );
				if ( 'undefined' !== typeof setWithExpiry ) {
					setWithExpiry( '.top-bar', 'closed', 0, 86400 * 60 * 24 ); // 1 Day
				}
			} );

			function getWithExpiry( key ) {
				const itemStr = localStorage.getItem( key );
				if ( ! itemStr ) {
					return null;
				}
				const item = JSON.parse( itemStr );
				const now = new Date();
				if ( now.getTime() > item.expiry ) {
					localStorage.removeItem( key );
					return null;
				}
				return item;
			}
			function setWithExpiry( key, value, discount = 0, ttl ) {
				const now = new Date();
				const item = {
					value,
					discount,
					expiry: now.getTime() + ttl,
				};
				localStorage.setItem( key, JSON.stringify( item ) );
			}
		} );
	};

	/**
	 * Toggle menu for mobile
	 */

	// var $header_height = jQuery("header").outerHeight();
	// jQuery("body").css('padding-top', $header_height+'px');
	//  jQuery(window).resize(function() {
	// 	});

	// jQuery(window).trigger('resize');

	// jQuery(window).scroll(function(){
	// 	$header_height = jQuery("header").outerHeight();
	// 	jQuery("body").css('padding-top', $header_height+'px');
	// });

	jQuery( '.menu-btn' ).on( 'click', function() {
		jQuery( this ).toggleClass( 'active' );
		jQuery( '.nav-overlay' ).toggleClass( 'open' );
		jQuery( 'html, body' ).toggleClass( 'no-overflow' );
		jQuery( '.header-nav ul li.active' ).removeClass( 'active' );
		jQuery( '.header-nav ul.sub-menu' ).slideUp();
	} );
	jQuery.noConflict();

	jQuery( '.program-teaser-slide > .program-teaser-head' ).on( 'click', function() {
		if ( jQuery( this ).parent().hasClass( 'active' ) ) {
			jQuery( this ).parent().removeClass( 'active' );
			jQuery( this ).siblings( '.program-teaser-text' ).slideUp( 300 );
		} else {
			jQuery( '.program-teaser-slide > .program-teaser-head' ).parent().removeClass( 'active' );
			jQuery( this ).parent().addClass( 'active' );
			jQuery( '.program-teaser-text' ).slideUp();
			jQuery( this ).siblings( '.program-teaser-text' ).slideDown( 300 );
		}
	} );

	jQuery.noConflict();

	/**
	 * Add span tag to multi-level accordion menu for mobile menus
	 */
	jQuery( 'li' ).each( function() {
		if ( jQuery( this ).hasClass( 'menu-item-has-children' ) ) {
			jQuery( this )
				.find( 'a:first' )
				.after( '<span class="submenu-icon"></span>' );
		}
	} );

	// Check If have Filter

	if ( jQuery( '.program-filter-ctn' )[ 0 ] ) {
		// Do something if class exists
		jQuery( 'body' ).addClass( 'has-category-filter' );
	}

	/**
	 * Stats
	 */

	jQuery(
		( function( jQuery, win ) {
			jQuery.fn.inViewport = function( cb ) {
				return this.each( function( i, el ) {
					function visPx() {
						const H = jQuery( this ).height(),
							r = el.getBoundingClientRect(),
							t = r.top,
							b = r.bottom;
						return cb.call(
							el,
							Math.max( 0, t > 0 ? H - t : b < H ? b : H )
						);
					}
					visPx();
					jQuery( win ).on( 'resize scroll', visPx );
				} );
			};
		} )( jQuery, window )
	);
	if ( jQuery( '.stat-number' ).length > 0 ) {
		jQuery( '.stat-number' ).inViewport( function( px ) {
			if ( px > 0 && ! this.initNumAnim ) {
				this.initNumAnim = true;
				const $this = jQuery( this ),
					countTo = $this.attr( 'data-number' );
				jQuery( {
					countNum: $this.text(),
				} ).animate(
					{
						countNum: countTo,
					},
					{
						duration: 2000,
						easing: 'swing',
						step() {
							// $this.text(Math.ceil(this.countNum));   showing commas during counter running
							$this.text(
								Math.ceil( this.countNum ).toLocaleString( 'en' )
							);
						},
						complete() {
							$this.text(
								Math.ceil( this.countNum ).toLocaleString( 'en' )
							);
						},
					}
				);
			}
		} );
	}
	/**
	 * Post Cats
	 */

	if ( jQuery( window ).width() < 748 ) {
		jQuery( document ).on( 'click keypress', '.post-cat-label', function() {
			if ( jQuery( this ).hasClass( 'active' ) ) {
				jQuery( this ).removeClass( 'active' );
				jQuery( this ).siblings( '.post-cats' ).slideUp( 300 );
			} else {
				jQuery( '.post-cat-label' ).removeClass( 'active' );
				jQuery( this ).addClass( 'active' );
				jQuery( '.post-cats' ).slideUp();
				jQuery( this ).siblings( '.post-cats' ).slideDown( 300 );
			}
		} );
	}

	if ( jQuery( window ).width() < 1004 ) {
		jQuery( document ).on( 'click keypress', '.expand-more', function() {
			if ( jQuery( this ).hasClass( 'active' ) ) {
				jQuery( this ).removeClass( 'active' );
				jQuery( this ).siblings( '.program-consortium-sticky-nav' ).slideUp( 300 );
			} else {
				jQuery( '.expand-more' ).removeClass( 'active' );
				jQuery( this ).addClass( 'active' );
				jQuery( '.program-consortium-sticky-nav' ).slideUp();
				jQuery( this ).siblings( '.program-consortium-sticky-nav' ).slideDown( 300 );
			}
		} );
	}

	/**
	 * Program Nav Jump links Script
	 */

	jQuery( document ).on( 'click keypress', '.has-child-items > a', function() {
		if ( jQuery( this ).hasClass( 'active' ) ) {
			jQuery( this ).removeClass( 'active' );
			jQuery( this ).siblings( '.child-items' ).slideUp( 300 );
		} else {
			jQuery( '.has-child-items > a' ).removeClass( 'active' );
			jQuery( this ).addClass( 'active' );
			jQuery( '.child-items' ).slideUp();
			jQuery( this ).siblings( '.child-items' ).slideDown( 300 );
		}
	} );

	/**
	 * Magnific Popup Script
	 */

	jQuery( function() {
		jQuery( '.open-bio-modal' ).magnificPopup( {
			type: 'inline',
			preloader: false,
			modal: false,
			closeMarkup: '',
			fixedContentPos: true,
			overflowY: 'hidden',
			callbacks: {
				beforeOpen() {
					this.st.mainClass = 'rotate-carouse-left';
				},
			},
		} );
		jQuery( '.closeBtn' ).on( 'click keypress', function( e ) {
			e.preventDefault();
			jQuery( '.mfp-wrap' ).addClass( 'mfp-removing' );
			setTimeout( function() {
				jQuery.magnificPopup.close();
			}, 500 );
		} );
	} );

	jQuery( function() {
		jQuery( '.contact-popup-button' ).magnificPopup( {
			type: 'inline',
			preloader: false,
			modal: false,
			closeMarkup: '',
			fixedContentPos: true,
			overflowY: 'hidden',
			callbacks: {

				 callbacks: {
		            open() {
		                jQuery( '.contact-popup-form' ).show();
		            },
		            close() {
		                jQuery( '.contact-popup-form' ).hide();
		            },
        		},
			},
		} );
		jQuery( '.contactCloseBtn' ).on( 'click keypress', function( e ) {
			e.preventDefault();
			jQuery( '.mfp-wrap' ).addClass( 'mfp-removing' );
			setTimeout( function() {
				jQuery.magnificPopup.close();
			}, 500 );
		} );
	} );
	/**
	 * Gallery Slider
	 */

	jQuery( '.story-slider-items' ).owlCarousel( {
		margin: 20,
		loop: true,
		items: 2,
		nav: true,
		dots: false,
		autoWidth: true,
		responsive: {
			0: {
				items: 1,
				stagePadding: 21,
				margin: 16,

			},
			748: {
				items: 1,
				stagePadding: 60,
				margin: 16,

			},
			900: {
				items: 2,
			},
			1180: {
				items: 4,
			},
		},
	} );
	jQuery( '.story-teaser-multiple-slider' ).owlCarousel( {
		loop: true,
		nav: true,
		dots: false,
		items: 1,
	} );

	/**
	 * Contact Quote Slider
	 */
	if ( jQuery( '.give-right .quote-slider' ).length > 0 ) {
		jQuery( '.give-right .quote-slider' ).owlCarousel( {
			margin: 26,
			loop: true,
			items: 1,
			nav: false,
			dots: false,
			autoWidth: true,
			stagePadding: 76,
			responsive: {
				0: {
					items: 1,
					margin: 19,
				},
				600: {
					items: 1,
				},
				1000: {
					items: 1,
				},
			},
		} );
	}

	/**
	 * Story Slider
	 */
	if ( jQuery( '.story-teaser-multi .story-teaser' ).length > 0 ) {
		if ( jQuery( window ).width() < 1004 ) {
			jQuery( '.story-teaser-multi .story-teaser' ).owlCarousel( {
				margin: 17,
				loop: true,
				items: 2,
				nav: true,
				dots: false,
				responsive: {
					0: {
						items: 1,
						stagePadding: 21,
					},
					600: {
						items: 2,
						stagePadding: 21,
					},
					768: {
						items: 2,
						stagePadding: 40,
					},
				},
			} );
		}
	}

	/**
	 * Timeline Slider
	 */

	if ( jQuery( 'body.program-detail-single .timeline-slider' ).length > 0 ) {
		jQuery( 'body.program-detail-single .timeline-slider' ).owlCarousel( {
			margin: 36,
			stagePadding: 20,
			loop: true,
			items: 2,
			nav: true,
			dots: false,
			responsive: {
				0: {
					items: 1,
					stagePadding: 55,
					margin: 54,
				},
				748: {
					items: 1,
					stagePadding: 80,
					margin: 60,
				},
				900: {
					items: 2,
					margin: 60,
					stagePadding: 80,
				},
				1180: {
					items: 2,
					margin: 82,
					stagePadding: 119,
				},
			},
		} );
	}

	/**
	 * Timeline Slider
	 */
	if ( jQuery( '.timeline-slider' ).length > 0 ) {
		jQuery( '.timeline-slider' ).owlCarousel( {
			margin: 82,
			loop: true,
			items: 2,
			nav: true,
			dots: false,
			stagePadding: 119,
			responsive: {
				0: {
					items: 1,
					stagePadding: 55,
					margin: 54,
				},
				748: {
					items: 1,
					stagePadding: 80,
					margin: 60,
				},
				900: {
					items: 2,
					margin: 60,
					stagePadding: 80,
				},
				1180: {
					items: 2,
					margin: 82,
					stagePadding: 119,
				},
			},
		} );
	}

	/**
	 *
	 *  Video Popup
	 *
	 *
	 */
	if ( jQuery( '.video-icon' ).length > 0 ) {
		jQuery( '.video-icon' ).addClass( 'video-playing' );

		jQuery( '.video-icon' ).on( 'click', function() {
			const video = jQuery( this ).prev( 'video' )[ 0 ];
			if ( video.paused ) {
				video.play();
			} else {
				video.pause();
			}

			jQuery( this ).toggleClass( 'video-playing' );
		} );
	}
	/**
	 * Video Magnific Popup
	 */
	if ( jQuery( '.video-block a' ).length > 0 ) {
		jQuery( '.video-block a' ).magnificPopup( {
			// disableOn: 700,
			type: 'iframe',
			mainClass: 'mfp-fade',
			removalDelay: 160,
			preloader: false,
			fixedContentPos: true,
			overflowY: 'hidden',
		} );
	}

	/**
	 * Slide Up/Down internal sub-menu when mobile menu arrow clicked
	 */

	jQuery( '.header-nav .submenu-icon' ).on( 'click', function() {
		const link = jQuery( this );
		const closestUl = link.closest( 'ul' );
		const parallelActiveLinks = closestUl.find( '.active' );
		const closestLi = link.closest( 'li' );
		const linkStatus = closestLi.hasClass( 'active' );
		let count = 0;

		closestUl.find( 'ul' ).slideUp( function() {
			if ( ++count === closestUl.find( 'ul' ).length ) {
				parallelActiveLinks.removeClass( 'active' );
			}
		} );

		if ( ! linkStatus ) {
			closestLi.children( 'ul' ).slideDown();
			closestLi.addClass( 'active' );
		}
	} );

	// Style Variations
	 const modeOptions = jQuery( 'input[name="mode"]' );
	const body = jQuery( 'body' );

	// Function to update the mode based on the selected radio button
	function updateMode() {
		const selectedMode = modeOptions.filter( ':checked' ).attr( 'id' );

		body.removeClass( 'dark-mode light-dark-mode high-contrast-mode' );

		if ( selectedMode === 'dark-mode' ) {
			body.addClass( 'dark-mode' );
			localStorage.setItem( 'mode', 'dark-mode' );
		} else if ( selectedMode === 'light-dark-mode' ) {
			body.addClass( 'light-dark-mode' );
			localStorage.setItem( 'mode', 'light-dark-mode' );
		} else if ( selectedMode === 'high-contrast-mode' ) {
			body.addClass( 'high-contrast-mode' );
			localStorage.setItem( 'mode', 'high-contrast-mode' );
		} else {
			// Default to light mode if no radio button is selected
			body.addClass( 'light-mode' );
			localStorage.setItem( 'mode', 'light-mode' );
		}
	}

	// Check local storage for user preference
	const userPreference = localStorage.getItem( 'mode' );
	if ( userPreference ) {
		modeOptions.filter( `#${ userPreference }` ).prop( 'checked', true );
		updateMode();
	}

	// Handle radio button change events
	modeOptions.change( updateMode );

	// Custom Filter

	const areaOfFocus = jQuery( '#area-of-focus-select' ).CustomSelect( );
	const programList = jQuery( '#program-list-select' ).CustomSelect( );

	jQuery( document ).on( 'click change', '.filter-item', function() {
		ajaxFun();
	} );
	jQuery( document ).on( 'change', '.search-item', function() {
		ajaxFun();
	} );
	jQuery( document ).on( 'click', '.clear-filter', function() {
		areaOfFocus.setValue( '' );
		programList.setValue( '' );
		jQuery( '.search-item[type="search"]' ).val( '' );
		ajaxFun();
	} );

	function ajaxFun() {
		const areaOfFocusValue = ( typeof areaOfFocus.getValue() !== 'undefined' ) ? areaOfFocus.getValue() : '';
		if ( '' === areaOfFocusValue ) {
			window.location.replace( localVars.home_url + '/programs' );
			return;
		}
		const programListValue = ( typeof programList.getValue() !== 'undefined' ) ? programList.getValue() : '';
		const search = ( typeof jQuery( '.search-item[type="search"]' ).val() !== 'undefined' ) ? encodeURIComponent( jQuery( '.search-item[type="search"]' ).val() ) : '';
		if ( history.pushState ) {
			const oldurl = window.location.protocol + '//' + window.location.host + window.location.pathname;
			let newurl = '';

			newurl = oldurl + '?';

			if ( programListValue != '' && areaOfFocusValue !== '' ) {
				newurl += 'area-of-focus=' + areaOfFocusValue;
				newurl += '&program-item=' + programListValue;
			} else if ( areaOfFocusValue !== '' ) {
				newurl += 'area-of-focus=' + areaOfFocusValue;
			} else if ( programListValue != '' ) {
				newurl += 'program-item=' + programListValue;
			}
			if ( search !== '' ) {
				newurl += '&search=' + search;
			}
			window.history.pushState( { path: newurl }, '', newurl );
			location.reload();
		}
	}
	// Draw Arrows with scrollTrigger
	if ( jQuery( '.draw-arrow' ).length > 0 ) {
		if ( jQuery( window ).width() > 1003 ) {
			gsap.fromTo( '.draw-arrow', {
				drawSVG: '32% 32%',
			}, {
				drawSVG: '0% 100%',
				ease: 'none',
				duration: 1.2,
				scrollTrigger: {
					trigger: '.home-hero-arrow',
					start: 'top 40%',
					end: 'bottom 50%',
					scrub: true,
					once: true, // Set once to true to play the animation only once
				},
				onComplete: () => {
					jQuery( '.line-arrow' ).addClass( 'active' );
				},
			} );
		}
	}
	if ( jQuery( '.draw-arrow' ).length > 0 ) {
		if ( jQuery( window ).width() < 1004 ) {
			gsap.fromTo( '.draw-arrow', {
				drawSVG: '0% 0%',
			}, {
				drawSVG: '0% 100%',
				ease: 'none',
				duration: 1.2,
				scrollTrigger: {
					trigger: '.home-hero-arrow',
					start: 'top 40%',
					end: 'bottom 40%',
					scrub: true,
					once: true, // Set once to true to play the animation only once
				},
				onComplete: () => {
					jQuery( '.line-arrow' ).addClass( 'active' );
				},
			} );
		}
	}
	if ( jQuery( '.program-teaser-line' ).length > 0 ) {
		gsap.fromTo( '.program-teaser-line', {
			drawSVG: '0% 0%',
		}, {
			drawSVG: '0% 100%',
			ease: 'none',
			duration: 1.2,
			scrollTrigger: {
				trigger: '.arrow-top',
				start: 'top 60%',
				end: 'bottom 40%',
				scrub: true,
				once: true, // Set once to true to play the animation only once
			},
			onComplete: () => {
				jQuery( '.program-line-arrow' ).addClass( 'active' );
			},
		} );
	}
	if ( jQuery( '.program-teaser-line-left' ).length > 0 ) {
		gsap.fromTo( '.program-teaser-line-left', {
			drawSVG: '0% 0%',
		}, {
			drawSVG: '0% 100%',
			ease: 'none',
			duration: 1.2,
			scrollTrigger: {
				trigger: '.program-teaser-arrow-left',
				start: 'top 35%',
				end: 'bottom 45%',
				scrub: true,
				once: true, // Set once to true to play the animation only once
			},
			onComplete: () => {
				jQuery( '.program-line-arrow-left' ).addClass( 'active' );
			},
		} );
	}
	if ( jQuery( '.hero-home h1 mark svg' ).length > 0 ) {
		gsap.fromTo( '.hero-home h1 mark svg', {
			alpha: .5,
			scaleX: '0',
			transformOrigin: 'left center',
		}, {
			alpha: 1,
			scaleX: '1',
			ease: 'power1',
			delay: 1,
			duration: .8,
			scrollTrigger: {
				trigger: '.hero-home-heading',
				start: 'top 50%',
				end: 'bottom 50%',
			},
		} );
	}
	// Wait for 1.8 seconds (1800 milliseconds) and then slide down the element
	if ( jQuery( '.hero-home-heading h1 div' ).length > 0 ) {
		setTimeout( function() {
			// jQuery( '.text_slide' ).addClass( 'show_text' );
			jQuery( '.hero-home-heading h1 div' ).slideDown( 600 );
		}, 2000 );
	}
} );
